import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, ListResponse } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { BotPlatform } from './platforms.abstraction';

@Injectable({ providedIn: 'root' })
export class PlatformsApiService extends ApiService {
  isLoading$ = this._isLoading$;

  getPlatforms(): Observable<ListResponse<BotPlatform>> {
    return this._httpClient.get<ListResponse<BotPlatform>>('@api/settings/bots/type/').pipe(
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }
}
